import { render } from "./RedCheckoutSuccess.vue?vue&type=template&id=2a8731f2&ts=true"
import script from "./RedCheckoutSuccess.vue?vue&type=script&lang=ts"
export * from "./RedCheckoutSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__